import Footer from '@/components/footer';
import AppLayoutTemplate from '@/layouts/app/app-header-layout';
import { type BreadcrumbItem } from '@/types';
import { type ReactNode } from 'react';

interface FrontendLayoutProps {
    children: ReactNode;
    breadcrumbs?: BreadcrumbItem[];
    contentClassName?: string;
}

export default ({ children, breadcrumbs, contentClassName, ...props }: FrontendLayoutProps) => (
    <AppLayoutTemplate breadcrumbs={breadcrumbs} contentClassName={contentClassName} {...props}>
        {children}
        <Footer />
    </AppLayoutTemplate>
);
